/**
 * Purpose:
 * Tailwind CSS class constants for ProtectedLayoutClient component.
 */

export const protectedLayoutStyles = {
  mainContainer: `
    min-h-screen bg-background
  `,

  contentContainer: `
    p-4 desktop:p-6
  `,

  mainBase: `
    pt-16
    relative z-[1]
  `,

  mainPaddingCollapsed: `
    desktop:pl-16
  `,

  mainPaddingExpanded: `
    desktop:pl-64
  `,

  mainTransition: `
    desktop:transition-[padding-left] desktop:duration-350 desktop:ease-[cubic-bezier(0.4,0,0.2,1)]
  `,
};

